var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isListLoading
    ? _c(
        "div",
        { ref: "tableWrapper", staticClass: "table-wrapper inner" },
        [
          _c(
            "md-table",
            {
              staticClass: "context-menu-support custom-paginated-table",
              attrs: { id: "bottom-marker" },
            },
            [
              _c(
                "md-table-row",
                { ref: "headerRow", staticClass: "table-header-row" },
                [
                  _c(
                    "md-table-head",
                    { ref: "headerCol1", staticClass: "fixed-col-1" },
                    [
                      _c("md-checkbox", {
                        staticClass: "table-checkbox table-head-checkbox",
                        model: {
                          value: _vm.isSelectAll,
                          callback: function ($$v) {
                            _vm.isSelectAll = $$v
                          },
                          expression: "isSelectAll",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("TableHeaderDropdown", {
                    ref: "headerCol2",
                    staticClass: "fixed-col-2",
                    attrs: {
                      "column-icon": "keyboard_arrow_down",
                      "default-text": _vm.selectedColumn.name,
                      "dropdown-options": _vm.columnDropdownOptions,
                      "selected-option": _vm.selectedColumn,
                    },
                    on: { selectedOption: _vm.handleSelectedColumn },
                  }),
                  _c(
                    "md-table-head",
                    { ref: "headerCol3", staticClass: "fixed-col-3" },
                    [_vm._v("Status")]
                  ),
                  _c("md-table-head", { staticClass: "scroll-col-4" }, [
                    _vm._v("Order Date"),
                  ]),
                  _vm.showCarrierOrders
                    ? _c(
                        "md-table-head",
                        {
                          directives: [
                            {
                              name: "feature",
                              rawName: "v-feature",
                              value: [_vm.featureNames.CarrierMarketplace],
                              expression: "[featureNames.CarrierMarketplace]",
                            },
                          ],
                        },
                        [_vm._v("\n                Carrier\n            ")]
                      )
                    : _vm._e(),
                  _c("md-table-head", [_vm._v("Ready Delivery Date")]),
                  _c("md-table-head", [_vm._v("Expected Delivery Date")]),
                  _c("md-table-head", [_vm._v("Items")]),
                  _c("md-table-head", [_vm._v("Shipping Address")]),
                  _c("md-table-head", [_vm._v("Customer Name")]),
                  _c("md-table-head", [_vm._v("Shipping Contact")]),
                  _vm.$root.isDesktop && !_vm.isReadOnlyUser
                    ? _c("md-table-head", [_vm._v("Actions")])
                    : _vm._e(),
                ],
                1
              ),
              _vm._l(_vm.orderList, function (order, rowIndex) {
                return _c(
                  "md-table-row",
                  { key: order.orderId },
                  [
                    _c(
                      "md-table-cell",
                      {
                        ref: "bodyCell" + rowIndex + "-1",
                        refInFor: true,
                        staticClass: "fixed-col-1",
                      },
                      [
                        _c("md-checkbox", {
                          staticClass: "table-checkbox",
                          attrs: { value: order },
                          on: {
                            change: function ($event) {
                              return _vm.singleCheckbox(order)
                            },
                          },
                          model: {
                            value: _vm.selectedOrders,
                            callback: function ($$v) {
                              _vm.selectedOrders = $$v
                            },
                            expression: "selectedOrders",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      {
                        ref: "bodyCell" + rowIndex + "-2",
                        refInFor: true,
                        staticClass: "fixed-col-2",
                      },
                      [
                        _vm.selectedColumn.key == "order-number"
                          ? _c(
                              "router-link",
                              {
                                staticClass: "ref-link",
                                attrs: {
                                  to: {
                                    name: "Order Details",
                                    params: { orderId: order.orderId },
                                  },
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(order.orderNumber) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "ref-link",
                                attrs: {
                                  to: {
                                    name: "Order Details",
                                    params: { orderId: order.orderId },
                                  },
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      order.sourceReference != null
                                        ? order.sourceReference
                                        : order.orderNumber
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      {
                        ref: "bodyCell" + rowIndex + "-3",
                        refInFor: true,
                        staticClass: "fixed-col-3",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "custom-badge",
                            class:
                              "status-" +
                              _vm.$_getBadgeStatusColor(order.status),
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(order.status) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "md-table-cell",
                      {
                        ref: "bodyCell" + rowIndex + "-4",
                        refInFor: true,
                        staticClass: "scroll-col-4",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("dateFormat")(
                                order.orderDate,
                                _vm.DATE_TYPES.standardDate
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm.showCarrierOrders
                      ? _c(
                          "md-table-cell",
                          {
                            directives: [
                              {
                                name: "feature",
                                rawName: "v-feature",
                                value: [_vm.featureNames.CarrierMarketplace],
                                expression: "[featureNames.CarrierMarketplace]",
                              },
                            ],
                            ref: "bodyCell" + rowIndex + "-10",
                            refInFor: true,
                            staticClass: "carrier-dropdown-cell",
                            class: _vm.isOrderLoading(order.orderId)
                              ? "no-padding"
                              : "",
                          },
                          [
                            _vm.isOrderLoading(order.orderId)
                              ? _c("skeleton", { attrs: { height: "40px" } })
                              : _c("carrier-service-rate-dropdown", {
                                  attrs: {
                                    "carrier-service-rates":
                                      order.carrierServiceRates,
                                    "assigned-carrier-service-rate":
                                      order.assignedCarrier,
                                    editable: _vm.canAssignCarrier,
                                  },
                                  on: {
                                    assignedCarrierChanged: function (
                                      eventData
                                    ) {
                                      return _vm.handleAssignedCarrierChanged({
                                        eventData: eventData,
                                        orderId: order.orderId,
                                      })
                                    },
                                  },
                                }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "md-table-cell",
                      { ref: "bodyCell" + rowIndex + "-5", refInFor: true },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("dateFormat")(
                                order.readyDeliveryAvailableDate,
                                _vm.DATE_TYPES.standardDate
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _c(
                      "md-table-cell",
                      { ref: "bodyCell" + rowIndex + "-6", refInFor: true },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("dateFormat")(
                                order.expectedDeliveryDate,
                                _vm.DATE_TYPES.standardDate
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _c("md-table-cell", [
                      _vm._v(
                        "\n                " +
                          _vm._s(order.itemCount) +
                          "\n            "
                      ),
                    ]),
                    _c(
                      "md-table-cell",
                      { ref: "bodyCell" + rowIndex + "-7", refInFor: true },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              order.shippingAddress != null
                                ? order.shippingAddress.city
                                : ""
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _c(
                      "md-table-cell",
                      { ref: "bodyCell" + rowIndex + "-8", refInFor: true },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              order.customerId != null
                                ? order.customer.name
                                : ""
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _c(
                      "md-table-cell",
                      { ref: "bodyCell" + rowIndex + "-9", refInFor: true },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(order.contact.name) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm.$root.isDesktop && !_vm.isReadOnlyUser
                      ? _c(
                          "md-table-cell",
                          { staticClass: "action-buttons" },
                          [
                            _vm._l(
                              _vm.tableBodyActionsToDisplay,
                              function (action, idx) {
                                return [
                                  action === "edit"
                                    ? _c(
                                        "md-button",
                                        {
                                          key: idx,
                                          class: [
                                            "md-warning md-just-icon md-round",
                                            _vm.isDisabled
                                              ? "button-disabled"
                                              : "",
                                          ],
                                          attrs: { title: "Update order" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateOrder(order)
                                            },
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("edit")])],
                                        1
                                      )
                                    : _vm._e(),
                                  action === "putOnHold"
                                    ? _c(
                                        "md-button",
                                        {
                                          key: idx,
                                          class: [
                                            "md-info md-just-icon md-round",
                                            _vm.isDisabled
                                              ? "button-disabled"
                                              : "",
                                          ],
                                          attrs: {
                                            title:
                                              order.status === "On Hold"
                                                ? "Unhold order"
                                                : "Place order on hold",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.putOrderOnHold(order)
                                            },
                                          },
                                        },
                                        [
                                          _c("md-icon", [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  order.status == "On Hold"
                                                    ? "play_circle_outline"
                                                    : "pause"
                                                ) +
                                                "\n                        "
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  action === "cancel"
                                    ? _c(
                                        "md-button",
                                        {
                                          key: idx,
                                          class: [
                                            "md-danger md-just-icon md-round",
                                            _vm.isDisabled
                                              ? "button-disabled"
                                              : "",
                                          ],
                                          attrs: { title: "Cancel order" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelOrder(order)
                                            },
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("close")])],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.isReadOnlyUser && action === "delete"
                                    ? _c("delete-order-button", {
                                        key: idx,
                                        attrs: {
                                          "order-id": order.orderId,
                                          status: order.status,
                                          "can-delete": order.canDelete,
                                        },
                                        on: { orderDeleted: _vm.handleDelete },
                                      })
                                    : _vm._e(),
                                ]
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm.orderList.length == 0
            ? _c("div", [
                _c("p", { staticClass: "no-result-message" }, [
                  _vm._v(
                    "No results matching your search/filter could be found."
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _c("div", [
        _c(
          "div",
          { staticClass: "loader" },
          [
            _c("fade-loader", { attrs: { loading: true, color: "#333333" } }),
            _c("span", [_vm._v("LOADING")]),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }